import { useTurnstile } from '@/hooks/use-turnstile';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

interface TurnstileWidgetProps {
  sitekey: string;
  theme?: 'light' | 'dark' | 'auto';
  size?: 'normal' | 'compact';
  onVerify: (token: string) => void;
  onError?: () => void;
  onExpired?: () => void;
}

export const TurnstileWidget = ({
  sitekey,
  theme = 'auto',
  size = 'normal',
  onVerify,
  onError,
  onExpired,
}: TurnstileWidgetProps) => {
  const { containerRef, error } = useTurnstile({
    sitekey,
    theme,
    size,
    callback: onVerify,
    errorCallback: onError,
    expiredCallback: onExpired,
  });

  return (
    <div className="space-y-2">
      <div ref={containerRef} className="flex justify-center" />
      {error && (
        <Alert variant="destructive" className="mt-2">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
    </div>
  );
};
